import { UIState } from './types';

const drawerOpen = (state: UIState): boolean => state.drawerOpen || false;

export {
  drawerOpen, // eslint-disable-line import/prefer-default-export
};
